class Branch {
	id = 0;
	branch_type_id = null;
	status_id = null;
	name = null;
	address = null;
	oib = null;
	registry_number = null;
	iban = null;
	country_id = null;
	county_id = null;
	headquarters = null;
	zip_code = null;
	registry_entry_date = null;
	founding_assembly_date = null;
	master_assembly_date = null;
	last_assembly_date = null;
	record_link = null;
	delivered_rulebook = null;
	rulebook_confirmed = false;
	president_id = null;
	president_confirmation = null;
	head_id = null;
	head_confirmation = null;
	vice_president_ids = [];
	secretary_id = null;
	literary_secretary_id = null;
	economic_secretary_id = null;
	board_member_id = null;
	mandate_expiration_date = null;
	note = null;
	phone_number = null;
	mobile_phone_number = null;
	email = null;
	facebook = null;
	web_site = null;
	activity_report_link = null;
	branch_site_link = null;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Branch;
